import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-md-none fixed-bottom",
  style: {"max-height":"8vh","justify-content":"space-around","display":"flex","background-color":"#fff","border-top":"1px solid #dee2e6"}
}
const _hoisted_2 = ["xlink:href"]
const _hoisted_3 = ["xlink:href"]
const _hoisted_4 = ["xlink:href"]
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (false && _ctx.$root.isMobile)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onHome && _ctx.onHome(...args))),
          style: {"color":"#333333","width":"15%"},
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("use", {
            "xlink:href": _ctx.urls.getIconURL('home')
          }, null, 8, _hoisted_2)
        ])),
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onStar && _ctx.onStar(...args))),
          style: {"color":"#333333","width":"15%"},
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("use", {
            "xlink:href": _ctx.urls.getIconURL('search')
          }, null, 8, _hoisted_3)
        ])),
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onStar && _ctx.onStar(...args))),
          style: {"color":"#333333","width":"15%"},
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("use", {
            "xlink:href": _ctx.urls.getIconURL('star')
          }, null, 8, _hoisted_4)
        ])),
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNew && _ctx.onNew(...args))),
          style: {"color":"#333333","width":"15%"},
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("use", {
            "xlink:href": _ctx.urls.getIconURL('new')
          }, null, 8, _hoisted_5)
        ])),
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPerson && _ctx.onPerson(...args))),
          style: {"color":"#333333","width":"15%"},
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("use", {
            "xlink:href": _ctx.urls.getIconURL('person')
          }, null, 8, _hoisted_6)
        ]))
      ]))
    : _createCommentVNode("", true)
}